"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCents = void 0;
function transformCents(value, options = { fractionDigits: 2, fixedDecimals: 2 }) {
    const { fractionDigits, fixedDecimals = 0 } = typeof options === 'number'
        ? { fractionDigits: options }
        : options;
    const res = value / Math.pow(10, fractionDigits);
    if (fixedDecimals > 0) {
        return +res.toFixed(fixedDecimals);
    }
    return res;
}
exports.transformCents = transformCents;
